

import { useEffect, useState } from "react";
import DragAndDrop from "./StreckenverlaufDragAndDrop";
import { useNavigate } from "react-router-dom";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function StreckeBasedOn({ strInstance, strVerlInstance, bhfInstance }) {
    const navigate = useNavigate();

    const [filteredHrBhfListe, setFilteredHrBhfListe] = useState([]);
    const [streckenListe, setStreckenListe] = useState({
        suchanfrage: {
            idStartBhf: undefined,
            idEndBhf: undefined
        },
        allStrecken: [],
        showVerlauf: {}
    });
    const [bhfListe, setBhfListe] = useState([]);

    const [allItems, setAllItems] = useState({
        base: [],
        extra: [],
        del: []
    });

    useEffect(() => {
        bhfInstance.getListOfBahnhofsBahnhoflisteGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setBhfListe(data);
            }
        });
    }, [bhfInstance]);

    function handleStartBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idStartBhf: e.target.value
            }
        });

        filterBhfListe(e.target.value);
    }

    function handleEndBhfChange(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            suchanfrage: {
                ...streckenListe.suchanfrage,
                idEndBhf: e.target.value
            }
        });
    }

    function filterBhfListe(idStartBhf) {
        strInstance.getPossibleEnds(idStartBhf, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load bhfListe', data);
                setFilteredHrBhfListe(data);
            }
        })
    }

    function handleStreckenLoad(data) {
        let verlaufShow = {};
        data.forEach(str => verlaufShow[str.id_strecke] = false);
        setStreckenListe({
            ...streckenListe,
            allStrecken: data,
            showVerlauf: verlaufShow
        });
    }

    function handleVerlaufShow(e) {
        e.preventDefault();
        setStreckenListe({
            ...streckenListe,
            showVerlauf: {
                ...streckenListe.showVerlauf,
                [e.target.value]: !streckenListe.showVerlauf[e.target.value]
            }
        });
    }

    const loadStrecken = (event) => {
        event.preventDefault();

        var startEnd = new MonitorApi.StreckeVonBis();
        startEnd.id_eins = streckenListe.suchanfrage.idStartBhf;
        startEnd.id_zwei = streckenListe.suchanfrage.idEndBhf;
        strVerlInstance.searchStreckenverlaufStreckenverlaufSuchePatch(startEnd, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load Strecken HR', data);
                handleStreckenLoad(data);
            }
        })
    }

    function updateRadios(e) {
        // setAllItems({
        //     ...allItems,
        //     extra: [],
        //     base: [],
        //     del: []
        // });
        let specificStrecke = streckenListe.allStrecken
            .filter(str => str.id_strecke === parseInt(e.target.value))[0]
            .strecke;

        setAllItems({
            ...allItems,
            extra: [],
            del: [],
            base: specificStrecke.map(it => [{ id: it.id_bhf, bahnhof: it.bhf, col: "black" }][0])
        });
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    function handleExtraBahnhof(e) {
        e.preventDefault();
        setAllItems({
            ...allItems,
            extra: [...allItems.extra, bhfListe.filter(b => b.id === parseInt(e.target.value))[0]]
        });
    }

    function saveStrecke(event) {
        event.preventDefault();
        let list = allItems.base.map((it, index) => [{ ...it, id_bhf: it.id, pos: index }][0]);
        console.log(list);
        strVerlInstance.createStreckenverlaufBasedOn(list, (error, data, response) => {
            if (error) {
                console.log(error);
                FehlerauswertungErrResp(error, response);
            } else {
                console.log("saved", data);
                alert("Neue Strecke wurde angelegt.");
                navigate(`../infra`, { replace: true });

            }
        });
    }

    return (
        <div>
            <h1>Bestehende Infrastruktur erweitern</h1>
            <section >
                <h3>Strecke suchen:</h3>
                <label>Start-Bahnhof:</label>
                <select onChange={(event) => handleStartBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {bhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>

                <label>End-Bahnhof:</label>
                <select onChange={(event) => handleEndBhfChange(event)}>
                    <option hidden={true}>---Auswahl treffen---</option>
                    {filteredHrBhfListe.map(bhf => <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>)}
                </select>
                {<button disabled={!streckenListe.suchanfrage.idStartBhf || !streckenListe.suchanfrage.idEndBhf}
                    onClick={e => loadStrecken(e)}>Strecken suchen</button>}
                <div>
                    {streckenListe.allStrecken.map(strecke =>
                        <fieldset key={strecke.id_strecke}>
                            <label>
                                <input type="radio" value={strecke.id_strecke} name="strecke"
                                    onChange={event => updateRadios(event)} />
                                Anzahl Bahnhöfe: {strecke.strecke.length}
                            </label>
                            <>
                                <br></br>
                                <button style={{ margin: "1em 2em" }} value={strecke.id_strecke}
                                    onClick={(e) => handleVerlaufShow(e)}>
                                    {streckenListe.showVerlauf[strecke.id_strecke] ? <span>&#8722; </span> : <span>&#43; </span>}
                                    vollständiger Verlauf</button>
                            </>
                            {streckenListe.showVerlauf[strecke.id_strecke] &&
                                orderingVerlauf(strecke.strecke, strecke.mirrored).map(bhf => <label key={bhf.pos}>-{bhf.pos}: {bhf.bhf}-</label>)}
                        </fieldset>)
                    }
                </div>
            </section>
            <section>
                <h3>Bahnhof hinzufügen</h3>
                <select onChange={(event) => handleExtraBahnhof(event)}>
                    <option hidden={true}>...weitere Bahnhöfe</option>
                    {bhfListe.map(bhf =>
                        <option key={bhf.id} value={bhf.id}>{bhf.bahnhof}</option>
                    )}
                </select>
            </section>
            <p>Sortierung wird erst beim Speichern überprüft. Nicht akzeptiert wird eine Infrastruktur, wenn: Abschnitte zwischen den Bahnhöfen fehlen, es Widersprüche mit den Gültigkeiten gibt.</p>
            {/* <section>
                <h4>Bhf aus Strecke</h4>
                <p>{JSON.stringify(allItems.base)}</p>

                <h4>Bhf neu dazu</h4>
                <p>{JSON.stringify(allItems.extra)}</p>

                <h4>Bhf zum Entfernen</h4>
                <p>{JSON.stringify(allItems.del)}</p>

            </section> */}
            <DragAndDrop allItems={allItems} setAllItems={setAllItems} />
            <button onClick={(event) => saveStrecke(event)}>Speichern</button>

        </div>
    );
}